module.exports = __webpack_public_path__ + "img/OK.32797d3f.svg";